<template>
    <button
      :class="buttonClasses"
      :disabled="disabled || loading"
      @click="handleClick"
      @mouseenter="isHovered = true"
      @mouseleave="isHovered = false"
      :style="buttonStyles"
    >
      <div class="button-content">
        <!-- Icône -->
        <transition name="icon-fade" mode="out-in">
          <component
            v-if="currentIcon"
            :is="currentIcon"
            :class="iconClasses"
            :key="loading ? 'loading' : 'default'"
          />
        </transition>

        <!-- Texte -->
        <!--span v-if="$slots.default || text" :class="textClasses">
          <slot>{{ text }}</slot>
        </span-->
        <span v-if="displayText" :class="textClasses">
            {{ displayText }}
        </span>
        <!-- Effet de ripple -->
        <div
          v-for="ripple in ripples"
          :key="ripple.id"
          class="ripple"
          :style="ripple.style"
        ></div>
      </div>
    </button>
  </template>
  
  <script>
  import { ref, computed, h } from 'vue'
  
  // Icônes SVG intégrées
  const CheckIcon = {
    template: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20,6 9,17 4,12"></polyline></svg>`
  }
  
  const TrashIcon = {
    render() {
        return h('svg', { width: '16', height: '16', viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', 'stroke-width': '2' }, [
        h('polyline', { points: '3,6 5,6 21,6' }),
        h('path', { d: 'm19,6v14a2,2 0 0,1 -2,2H7a2,2 0 0,1 -2,-2V6m3,0V4a2,2 0 0,1 2,-2h4a2,2 0 0,1 2,2v2' }),
        ]);
    }
  }
  
  const EditIcon = {
    //template: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="m18.5 2.5 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>`
    render() {
        return h('svg', { width: '16', height: '16', viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', 'stroke-width': '2' }, [
            h('path', { d: 'M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7' }),
            h('path', { d: 'm18.5 2.5 3 3L12 15l-4 1 1-4 9.5-9.5z' })
        ]);
    }
  }
  
  const SaveIcon = {
    //template: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path><polyline points="17,21 17,13 7,13 7,21"></polyline><polyline points="7,3 7,8 15,8"></polyline></svg>`
    render() {
        return h('svg', { width: '16', height: '16', viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', 'stroke-width': '2' }, [
            h('path', { d: 'M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z' }),
            h('polyline', { points: '17,21 17,13 7,13 7,21' }),
            h('polyline', { points: '7,3 7,8 15,8' })
        ]);
    }
  }
  
  const CancelIcon = {
    //template: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><path d="m15 9-6 6"></path><path d="m9 9 6 6"></path></svg>`
    render() {
        return h('svg', { width: '16', height: '16', viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', 'stroke-width': '2' }, [
            h('circle', { cx: '12', cy: '12', r: '10' }),
            h('path', { d: 'm15 9-6 6' }),
            h('path', { d: 'm9 9 6 6' })
        ]);
    }
  }
  
  const LoadingIcon = {
    //template: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="animate-spin"><path d="M21 12a9 9 0 1 1-6.219-8.56"></path></svg>`
    render() {
        return h('svg', { width: '16', height: '16', viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', 'stroke-width': '2', class: 'animate-spin' }, [
            h('path', { d: 'M21 12a9 9 0 1 1-6.219-8.56' })
        ]);
    }
  }
  
  const PlusIcon = {
    //template: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><path d="m15,12h-6"></path><path d="m12,15v-6"></path></svg>`
    render() {
        return h('svg', { width: '16', height: '16', viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', 'stroke-width': '2' }, [
            h('circle', { cx: '12', cy: '12', r: '10' }),
            h('path', { d: 'm15,12h-6' }),
            h('path', { d: 'm12,15v-6' })
        ]);
    }
  }
  
  export default {
    name: 'APButton',
    components: {
      CheckIcon,
      TrashIcon,
      EditIcon,
      SaveIcon,
      CancelIcon,
      LoadingIcon,
      PlusIcon
    },
    props: {
      // Type de bouton prédéfini
      variant: {
        type: String,
        default: 'primary',
        validator: value => ['primary', 'secondary', 'ternary', 'success', 'danger', 'warning', 'ghost', 'outline'].includes(value)
      },
      
      // Type d'action
      action: {
        type: String,
        default: null,
        validator: value => !value || ['validate', 'delete', 'edit', 'save', 'cancel', 'add'].includes(value)
      },
      
      // Taille
      size: {
        type: String,
        default: 'md',
        validator: value => ['xs', 'sm', 'md', 'lg', 'xl'].includes(value)
      },
      
      // Texte du bouton
      text: {
        type: String,
        default: ''
      },
      
      // Icône personnalisée
      icon: {
        type: String,
        default: null
      },
      
      // Position de l'icône
      iconPosition: {
        type: String,
        default: 'left',
        validator: value => ['left', 'right', 'only'].includes(value)
      },
      
      // États
      disabled: {
        type: Boolean,
        default: false
      },
      
      loading: {
        type: Boolean,
        default: false
      },
      
      // Style
      rounded: {
        type: Boolean,
        default: false
      },
      
      shadow: {
        type: Boolean,
        default: true
      },
      
      gradient: {
        type: Boolean,
        default: false
      },
      
      // Animation
      ripple: {
        type: Boolean,
        default: true
      }
    },
    
    emits: ['click'],
    
    setup(props, { emit }) {
      const isHovered = ref(false)
      const ripples = ref([])
      
      // Icône basée sur l'action
      const actionIcons = {
        validate: 'CheckIcon',
        delete: 'TrashIcon',
        edit: 'EditIcon',
        save: 'SaveIcon',
        cancel: 'CancelIcon',
        add: 'PlusIcon'
      }
      
      // Texte par défaut basé sur l'action
      const actionTexts = {
        validate: 'Valider',
        delete: 'Supprimer',
        edit: 'Modifier',
        save: 'Sauvegarder',
        cancel: 'Annuler',
        add: 'Ajouter'
      }
      
      const currentIcon = computed(() => {
        if (props.loading) return 'LoadingIcon'
        if (props.icon) return props.icon
        if (props.action) return actionIcons[props.action]
        return null
      })
      
      const displayText = computed(() => {
        if (props.text) return props.text
        if (props.action) return actionTexts[props.action]
        return ''
      })
      
      // Classes CSS dynamiques
      const buttonClasses = computed(() => {
        const base = [
          'modern-button',
          `modern-button--${props.variant}`,
          `modern-button--${props.size}`,
          {
            'modern-button--rounded': props.rounded,
            'modern-button--shadow': props.shadow,
            'modern-button--gradient': props.gradient,
            'modern-button--disabled': props.disabled || props.loading,
            'modern-button--loading': props.loading,
            'modern-button--icon-only': props.iconPosition === 'only' || (!displayText.value && currentIcon.value)
          }
        ]
        
        // Classes spécifiques aux actions
        if (props.action) {
          base.push(`modern-button--action-${props.action}`)
        }
        
        return base
      })
      
      const iconClasses = computed(() => [
        'modern-button__icon',
        `modern-button__icon--${props.iconPosition}`,
        {
          'modern-button__icon--loading': props.loading
        }
      ])
      
      const textClasses = computed(() => [
        'modern-button__text',
        {
          'modern-button__text--hidden': props.iconPosition === 'only'
        }
      ])
      
      const buttonStyles = computed(() => {
        const styles = {}
        
        if (props.gradient) {
          const gradients = {
            primary: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            success: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
            danger: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
            warning: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)'
          }
          
          if (gradients[props.variant]) {
            styles.background = gradients[props.variant]
          }
        }
        
        return styles
      })
      
      const handleClick = (event) => {
        if (props.disabled || props.loading) return
        
        // Effet ripple
        if (props.ripple) {
          createRipple(event)
        }
        
        emit('click', event)
      }
      
      const createRipple = (event) => {
        const button = event.currentTarget
        const rect = button.getBoundingClientRect()
        const size = Math.max(rect.width, rect.height)
        const x = event.clientX - rect.left - size / 2
        const y = event.clientY - rect.top - size / 2
        
        const ripple = {
          id: Date.now(),
          style: {
            width: `${size}px`,
            height: `${size}px`,
            left: `${x}px`,
            top: `${y}px`
          }
        }
        
        ripples.value.push(ripple)
        
        setTimeout(() => {
          ripples.value = ripples.value.filter(r => r.id !== ripple.id)
        }, 600)
      }
      
      return {
        isHovered,
        ripples,
        currentIcon,
        displayText,
        buttonClasses,
        iconClasses,
        textClasses,
        buttonStyles,
        handleClick
      }
    }
  }
  </script>
  
  <style scoped>
  .modern-button {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    font-weight: 600;
    border: none;
    cursor: pointer;
    overflow: hidden;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    backdrop-filter: blur(10px);
    user-select: none;
    outline: none;
    text-decoration: none;
  }
  
  .modern-button:focus-visible {
    box-shadow: 0 0 0 3px rgba(var(--anima-primary-color), 0.5);
  }
  
  /* Tailles */
  .modern-button--xs {
    padding: 0.375rem 0.75rem;
    font-size: 0.75rem;
    min-height: 2rem;
  }
  
  .modern-button--sm {
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
    min-height: 2.25rem;
  }
  
  .modern-button--md {
    padding: 0.625rem 1.25rem;
    font-size: 0.875rem;
    min-height: 2.5rem;
  }
  
  .modern-button--lg {
    padding: 0.75rem 1.5rem;
    font-size: 1rem;
    min-height: 3rem;
  }
  
  .modern-button--xl {
    padding: 1rem 2rem;
    font-size: 1.125rem;
    min-height: 3.5rem;
  }
  
  /* Bouton icône seulement */
  .modern-button--icon-only {
    aspect-ratio: 1;
    padding: 0.625rem;
  }
  
  .modern-button--icon-only.modern-button--xs {
    padding: 0.375rem;
  }
  
  .modern-button--icon-only.modern-button--sm {
    padding: 0.5rem;
  }
  
  .modern-button--icon-only.modern-button--lg {
    padding: 0.75rem;
  }
  
  .modern-button--icon-only.modern-button--xl {
    padding: 1rem;
  }
  
  /* Variantes de couleur */
  .modern-button--primary {
    background: linear-gradient(135deg, var(--anima-primary-color), var(--anima-primary-color));
    color: white;
    border-radius: 0.75rem;
  }
  
  .modern-button--primary:hover:not(.modern-button--disabled) {
    background: linear-gradient(135deg, var(--anima-secondary-color), var(--anima-secondary-color));
    transform: translateY(-2px);
  }
  
  .modern-button--secondary {
    background: linear-gradient(135deg, #6b7280, #374151);
    color: white;
    border-radius: 0.75rem;
  }
  
  .modern-button--secondary:hover:not(.modern-button--disabled) {
    background: linear-gradient(135deg, #4b5563, #1f2937);
    transform: translateY(-2px);
  }
  
  .modern-button--ternary {
    background: white;
    color: var(--anima-primary-color);
    border-radius: 0.75rem;
    border-color: var(--anima-primary-color);
  }
  
  .modern-button--ternary:hover:not(.modern-button--disabled) {
    background: linear-gradient(135deg, #4b5563, #1f2937);
    transform: translateY(-2px);
  }

  .modern-button--success {
    background: linear-gradient(135deg, #10b981, #047857);
    color: white;
    border-radius: 0.75rem;
  }
  
  .modern-button--success:hover:not(.modern-button--disabled) {
    background: linear-gradient(135deg, #059669, #065f46);
    transform: translateY(-2px);
  }
  
  .modern-button--danger {
    background: linear-gradient(135deg, #ef4444, #dc2626);
    color: white;
    border-radius: 0.75rem;
  }
  
  .modern-button--danger:hover:not(.modern-button--disabled) {
    background: linear-gradient(135deg, #dc2626, #b91c1c);
    transform: translateY(-2px);
  }
  
  .modern-button--warning {
    background: linear-gradient(135deg, #f59e0b, #d97706);
    color: white;
    border-radius: 0.75rem;
  }
  
  .modern-button--warning:hover:not(.modern-button--disabled) {
    background: linear-gradient(135deg, #d97706, #b45309);
    transform: translateY(-2px);
  }
  
  .modern-button--ghost {
    background: rgba(255, 255, 255, 0.1);
    color: #374151;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 0.75rem;
    backdrop-filter: blur(10px);
  }
  
  .modern-button--ghost:hover:not(.modern-button--disabled) {
    background: rgba(255, 255, 255, 0.2);
    transform: translateY(-2px);
  }
  
  .modern-button--outline {
    background: transparent;
    color: var(--anima-primary-color);
    border: 2px solid var(--anima-primary-color);
    border-radius: 0.75rem;
  }
  
  .modern-button--outline:hover:not(.modern-button--disabled) {
    background: var(--anima-primary-color);
    color: white;
    transform: translateY(-2px);
  }
  
  /* Actions spécifiques */
  .modern-button--action-delete {
    background: linear-gradient(135deg, #ef4444, #dc2626);
  }
  
  .modern-button--action-validate {
    background: linear-gradient(135deg, #10b981, #047857);
  }
  
  /* Coins arrondis */
  .modern-button--rounded {
    border-radius: 9999px !important;
  }
  
  /* Ombre */
  .modern-button--shadow {
    box-shadow: 
      0 4px 6px -1px rgba(0, 0, 0, 0.1),
      0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }
  
  .modern-button--shadow:hover:not(.modern-button--disabled) {
    box-shadow: 
      0 10px 15px -3px rgba(0, 0, 0, 0.1),
      0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }
  
  /* État désactivé */
  .modern-button--disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none !important;
    pointer-events: none;
  }
  
  /* État de chargement */
  .modern-button--loading {
    cursor: wait;
    pointer-events: none;
  }
  
  /* Contenu du bouton */
  .button-content {
    position: relative;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    z-index: 1;
  }
  
  /* Icône */
  .modern-button__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  
  .modern-button__icon--loading {
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
  
  /* Texte */
  .modern-button__text {
    white-space: nowrap;
  }
  
  .modern-button__text--hidden {
    display: none;
  }
  
  /* Effet ripple */
  .ripple {
    position: absolute;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.3);
    pointer-events: none;
    transform: scale(0);
    animation: ripple-effect 0.6s linear;
    z-index: 0;
  }
  
  @keyframes ripple-effect {
    to {
      transform: scale(2);
      opacity: 0;
    }
  }
  
  /* Transitions pour les icônes */
  .icon-fade-enter-active,
  .icon-fade-leave-active {
    transition: opacity 0.2s ease;
  }
  
  .icon-fade-enter-from,
  .icon-fade-leave-to {
    opacity: 0;
  }
  
  /* Animation de l'icône de chargement */
  .animate-spin {
    animation: spin 1s linear infinite;
  }
  
  /* Responsive */
  @media (max-width: 640px) {
    .modern-button {
      min-width: 44px;
      min-height: 44px;
    }
  }
  
  /* Mode sombre */
  @media (prefers-color-scheme: dark) {
    .modern-button--ghost {
      background: rgba(0, 0, 0, 0.2);
      color: #f3f4f6;
      border-color: rgba(255, 255, 255, 0.1);
    }
    
    .modern-button--ghost:hover:not(.modern-button--disabled) {
      background: rgba(0, 0, 0, 0.3);
    }
    
    .modern-button--outline {
      color: var(--anima-secondary-color);
      border-color: var(--anima-secondary-color);
    }
    
    .modern-button--outline:hover:not(.modern-button--disabled) {
      background: var(--anima-secondary-color);
    }
  }
  
  /* Effet de focus amélioré */
  .modern-button:focus-visible {
    outline: 2px solid transparent;
    box-shadow: 0 0 0 3px rgba(var(--anima-primary-color), 0.5);
  }
  
  /* Animation au survol pour les gradients */
  .modern-button--gradient {
    background-size: 200% 200%;
    animation: gradient-shift 3s ease infinite;
  }
  
  @keyframes gradient-shift {
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
  }
  </style>